import { useFilterRoleContext } from "./filter-role.context";

export function FilterRole() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterRoleContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}